import React from 'react';
import { BehaviorSubject } from 'rxjs';

const popupSubject = new BehaviorSubject(null);

export const PopupService = {
    showPopup,
    closePopup,
    popup: popupSubject.asObservable(),
    get popupValue() { return popupSubject.value }
}

function closePopup() {
    popupSubject.next(null);
}

function showPopup(popup) {
    let props = { closeAction: closePopup };
    let popupClosed = React.cloneElement(popup, props);
    popupSubject.next(popupClosed);
}